import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const sendMagicLinkReducer = createReducer<State, Actions>(initialState, {
  [actions.sendMagicLink.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.sendMagicLink.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.sendMagicLink.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.sendMagicLink.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default sendMagicLinkReducer;
